import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { TYPE_RADIO, TYPE_DOWN_ANSWER, TYPE_CHECKBOX } from '@/modules/question/preview-question/_store/constants'
const state = {
    questionIdSelect:0,
    bookId:0,
    typeQuestion:{},
    paramExam:{examTypeId:1},
    question: { type:  TYPE_RADIO, answers:[], guideContent:"", suggestion:"", answerDetail:"", level:null, isDeleted:false , layoutId:1},
    question_format: [
        {
            value: TYPE_RADIO,
            name: 'Trắc nghiệm'
        },
        {
            value: TYPE_CHECKBOX,
            name: 'Trắc nghiệm có nhiều câu trả lời đúng'
        },
        {
            value: TYPE_DOWN_ANSWER,
            name: 'Tự luận'
        },
    ],
    paramSearch: { classId: 0, subjectId: 0, keyword: '', pageIndex: 1, pageSize: 12 },
    classes: [],
    slidesMain: [],
    slidesMainImg: [],
    objActivitySlide: {},
    slideCurr: null,
    slideIndexVisible: -1,
    linkVideoAudio: '',
    mediaPreviewData: [],
    isOpenSlideshow: false,
    indexPreviewMedia: -1,
    paramsSearchMediaDetail: {classId: 0, subjectId: 0, documentTypeId: 1, keyword: '', pageIndex: 1, pageSize: 12},
    scaleSlide: 1,
    scaleMax: 2,
    scaleMin: 0.5,
    idModalFileUploaded: 'modal_uploaded',
    isOpenModalFileUploaded: false,
    keySidebarActive: '',
    // Prepare exam
    examTimesToDo: [
        { value: 15, name: '15 phút' },
        { value: 30, name: '30 phút' },
        { value: 45, name: '45 phút' },
        { value: 60, name: '60 phút' },
        { value: 90, name: '90 phút' },
        { value: 120, name: '120 phút' }
    ],
    examInfo: {},
    questionList: [],
    questionDetail: {},
    indexQuestionWorking: -1,
    idModalQuestionSample: 'modal_question_sample',
    classesExam: [],
    subjectsExam: [],
    paramsGetQuestionsSample: {classId: 0, subjectId: 0, type: 1},
    bookIdQuestions: 0,
    bookIndexIdQuestions: 0,
    questionsSample: [],
    questionsChoose: [],
    questionsIdChoose: [],
    chapterIdQuestion: 0,
    paramFilterQuestionsByChapter: {chapterId: 0, examId: 0, keyword: ''},
    paramFilterQuestionsByExam:{examId:0}
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};